import React from 'react';
import { Tag } from 'antd';

export default function DashboardStatusTag({ children, color = 'default', ...tagProps }) {
  return (
    <Tag color={color} {...tagProps}>
      {children}
    </Tag>
  );
}
